import {makeApiUrl} from './../helpers/makeApiUrl';
import {requestOption}from './../helpers/requestOption';
import {handleResponse} from "../helpers/handleResponse";
import pl from './data/pl';
import en from './data/en';





class TJS {

    constructor(langData) {
    	this.langData = langData;
	}
	t(label, defValue, force, lang) {
		label = 'js-'+label.toUpperCase()
		if (typeof this.langData[lang] === 'undefined' || !this.langData[lang][label]) {
			this.insertToDB(label, defValue, force)
			return (typeof defValue != 'undefined' && typeof defValue.pl != 'undefined') ? defValue.pl : "[M:" + label + "]"
		}
		if (typeof force != 'undefined' && force) {
			this.insertToDB(label, defValue, force)
		}
		return this.langData[lang][label]
	}

	insertToDB(name, value, force) {
		if (typeof value == 'undefined') {
			return null;
		}
		let data = [];
		for ( var key in value ) {
        	data['values['+key+']'] = value[key]
    	}
    	data['name'] = name;
    	data['force_update'] = (typeof force != 'undefined' && force) ? true : false;
    	fetch(makeApiUrl('dev/i18n-label-setup'), requestOption(data))
	}
}

const  languages =  {'pl': pl, 'en': en};
let tjs = new TJS(languages);


/**
 * przykladowe wywolanie funkcji z automatycznym wrzuceniem
 * tlumaczen do bazy danych:
 *
 * _t('yup-mixed-required', {'pl': 'Pole jest wymagane.', 'en': 'Field required.'}, true)
 *
 * automatyczne usuwanie z js zdefiniowanych tlumaczen:
 *
 * search: (_t\(['"][a-z\-\_]+['"])[,\- {'":.$}a-złąśćóżęź]+\)
 * replace: $1)
 */
export function _t(label, defValue, force) {
		return tjs.t(label, defValue, force, global.lang);
}
